import { ROUTER_WITH_LOCALES } from 'src/constants';

export * from './menuLinks';

export const FORM_ID = 'FOOTER_SEARCH';
export const FIXED_FOOTER_LOCATIONS = [ROUTER_WITH_LOCALES.RACES];
